var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 792 612",
    enableBackground: "new 0 0 792 612",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 17.8828 31.6768)",
    fontFamily: "'Montserrat'",
    fontSize: "24px"
  }, "Camping des \xEEles 2008"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 505.5591 25.2354)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fill: "#7B6A58",
    fontFamily: "'Montserrat'",
    fontSize: "12px"
  }, "685, route des \xEEles, Saint-Hilaire-de-Dorset, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14.4,
    fill: "#7B6A58",
    fontFamily: "'Montserrat'",
    fontSize: "12px"
  }, "Beauce, Qu\xE9bec")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 623.9707 39.6768)",
    fill: "#7B6A58",
    fontFamily: "'Montserrat'",
    fontSize: "9px"
  }, "T\xE9l\xE9phone: 418-459-3521"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Border"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.147,
    y: 55.649,
    fill: "#FFFFFF",
    stroke: "#CBBBA0",
    strokeMiterlimit: 10,
    width: 782.353,
    height: 488.235
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Legend"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 33.8853 560.418)",
    fill: "#7B6A58",
    fontFamily: "'Montserrat'",
    fontSize: "10px"
  }, "Saisonnier libre"), /*#__PURE__*/React.createElement("rect", {
    x: 18.802,
    y: 552.5,
    fill: "#FFFFFF",
    stroke: "#A48A7B",
    strokeMiterlimit: 10,
    width: 8.885,
    height: 9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 33.8853 573.75)",
    fill: "#7B6A58",
    fontFamily: "'Montserrat'",
    fontSize: "10px"
  }, "Saisonnier lou\xE9"), /*#__PURE__*/React.createElement("rect", {
    x: 18.802,
    y: 566,
    stroke: "#A48A7B",
    strokeMiterlimit: 10,
    width: 8.885,
    height: 9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    fill: "#7B6A58",
    d: "M709.31,555.424h-8.636c-0.827,0-1.499,0.672-1.499,1.5v10.353 c0,0.828,0.672,1.5,1.499,1.5h8.636c0.828,0,1.5-0.672,1.5-1.5v-10.353C710.81,556.096,710.139,555.424,709.31,555.424z  M707.946,556.375c0.387,0,0.7,0.313,0.7,0.699c0,0.387-0.313,0.699-0.7,0.699c-0.386,0-0.698-0.313-0.698-0.699 C707.248,556.688,707.56,556.375,707.946,556.375z M705.709,556.375c0.387,0,0.699,0.313,0.699,0.699 c0,0.387-0.313,0.699-0.699,0.699s-0.699-0.313-0.699-0.699C705.01,556.688,705.322,556.375,705.709,556.375z M704.993,567.21 c-1.938,0-3.511-1.571-3.511-3.51s1.572-3.511,3.511-3.511c1.938,0,3.511,1.572,3.511,3.511S706.932,567.21,704.993,567.21z  M709.004,559.284h-8.022c-0.248,0-0.447-0.201-0.447-0.448c0-0.247,0.199-0.447,0.447-0.447h8.022 c0.248,0,0.448,0.2,0.448,0.447C709.452,559.083,709.252,559.284,709.004,559.284z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    fill: "#7B6A58",
    d: "M704.993,561.164c-1.399,0-2.537,1.138-2.537,2.536c0,1.399,1.138,2.537,2.537,2.537 c1.399,0,2.537-1.138,2.537-2.537C707.53,562.302,706.393,561.164,704.993,561.164z M704.993,561.946 c0.967,0,1.753,0.787,1.753,1.754c0,0.248-0.053,0.484-0.146,0.698c-0.484-0.103-0.916-0.081-1.484,0.003 c-0.289,0.044-0.648-0.03-0.905-0.173c-0.386-0.214-0.657-0.351-0.956-0.384c-0.004-0.048-0.014-0.095-0.014-0.145 C703.24,562.733,704.025,561.946,704.993,561.946z"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 718.1523 565)",
    fill: "#7B6A58",
    fontFamily: "'Montserrat'",
    fontSize: "10px"
  }, "Buanderie")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 718.1523 582.667)",
    fill: "#7B6A58",
    fontFamily: "'Montserrat'",
    fontSize: "10px"
  }, "Douches"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#7B6A58",
    cx: 701.965,
    cy: 593.009,
    r: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M701.844,599.464v3.057c-0.005,0.556-0.832,0.556-0.839,0v-3.057h-1.083l1.164-4.088h-0.189l-0.677,2.327 c-0.171,0.516-0.866,0.307-0.704-0.242l0.758-2.517c0.088-0.29,0.452-0.8,1.083-0.813h0.568h0.649 c0.613,0.013,0.979,0.526,1.083,0.813l0.758,2.517c0.153,0.547-0.537,0.771-0.704,0.242l-0.677-2.327h-0.216l1.19,4.088h-1.109 v3.057c0.009,0.556-0.815,0.554-0.811,0v-3.057H701.844z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B6A58",
    cx: 709.164,
    cy: 593.009,
    r: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M708.23,594.132c-0.676,0-1.109,0.585-1.109,1.163v2.706c-0.006,0.529,0.756,0.529,0.758,0v-2.489h0.189 v6.874c-0.012,0.718,1.002,0.697,1.002,0v-4.005h0.161v4.005c0.014,0.697,1.033,0.718,1.028,0v-6.874h0.189v2.489 c-0.008,0.533,0.749,0.533,0.759,0v-2.706c-0.011-0.578-0.461-1.153-1.137-1.163H708.23z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 705.118,
    y: 592.237,
    fill: "#7B6A58",
    width: 1.002,
    height: 10.636
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 718.1523 600.668)",
    fill: "#7B6A58",
    fontFamily: "'Montserrat'",
    fontSize: "10px"
  }, "Toilettes")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 33.8853 587.75)",
    fill: "#7B6A58",
    fontFamily: "'Montserrat'",
    fontSize: "10px"
  }, "Passager libre"), /*#__PURE__*/React.createElement("rect", {
    x: 18.802,
    y: 580,
    fill: "#36A9E1",
    stroke: "#A48A7B",
    strokeMiterlimit: 10,
    width: 8.885,
    height: 9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M707.281,580.816c1.043,0,1.887-0.846,1.887-1.889c0-1.043-0.844-1.887-1.887-1.887 c-1.044,0-1.891,0.844-1.891,1.887C705.391,579.971,706.237,580.816,707.281,580.816z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M705.502,585.404c0,0.202,0.162,0.469,0.367,0.469v-0.004h0.871v0.004c0.207,0,0.47-0.263,0.47-0.465 v-1.606c0-0.202-0.263-0.461-0.47-0.461h-0.871c-0.191,0-0.348,0.243-0.367,0.427l0,0l0,0 C706.756,583.768,706.748,585.404,705.502,585.404L705.502,585.404z M704.71,581.42c0.202-0.195,0.476-0.313,0.776-0.313h3.723 l3.745-3.756c0.804-0.807,1.854,0.24,1.051,1.047l-4.108,4.12l0.003,5.625h-4.928v-2.732h-2.226c-0.465,0-0.842-0.375-0.842-0.84 c0-0.2,0.068-0.38,0.182-0.526L704.71,581.42z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7B6A58",
    points: "698.757,574.086 699.214,574.545 701.425,572.285 700.967,571.828 699.965,572.207 699.505,571.75 698.582,572.668 699.04,573.131  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M702.16,581.265c-0.044,0.278,0.148,0.529,0.42,0.567c0.273,0.045,0.533-0.154,0.566-0.42 c0.042-0.278-0.146-0.529-0.422-0.568C702.453,580.804,702.195,580.991,702.16,581.265z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M702.594,580.124c0.037-0.262-0.141-0.502-0.402-0.54c-0.26-0.037-0.5,0.143-0.539,0.402 c-0.037,0.266,0.144,0.498,0.402,0.536C702.313,580.563,702.559,580.38,702.594,580.124z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M702.039,578.838c0.034-0.248-0.133-0.477-0.381-0.516c-0.246-0.033-0.474,0.137-0.51,0.383 c-0.036,0.253,0.133,0.474,0.379,0.512C701.775,579.258,702.006,579.078,702.039,578.838z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M701.486,577.551c0.033-0.232-0.125-0.45-0.361-0.484c-0.236-0.033-0.449,0.128-0.482,0.361 c-0.034,0.234,0.127,0.446,0.359,0.483C701.235,577.948,701.455,577.779,701.486,577.551z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M700.933,576.264c0.032-0.223-0.12-0.428-0.339-0.457c-0.223-0.031-0.426,0.119-0.456,0.34 c-0.032,0.227,0.118,0.421,0.337,0.458C700.697,576.639,700.902,576.481,700.933,576.264z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M699.631,574.867c-0.033,0.21,0.113,0.393,0.319,0.429c0.206,0.034,0.398-0.116,0.429-0.319 c0.029-0.207-0.111-0.401-0.318-0.428C699.848,574.519,699.658,574.66,699.631,574.867z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M704.023,579.449c0.013-0.27,0.246-0.484,0.518-0.47c0.273,0.016,0.482,0.244,0.469,0.523 c-0.01,0.273-0.244,0.48-0.519,0.465C704.221,579.959,704.008,579.727,704.023,579.449z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M703.711,578.912c-0.258-0.01-0.461-0.229-0.445-0.494c0.014-0.26,0.234-0.459,0.493-0.447 c0.261,0.016,0.458,0.232,0.445,0.495C704.193,578.729,703.973,578.924,703.711,578.912z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M702.934,577.854c-0.247-0.012-0.438-0.218-0.425-0.466c0.013-0.247,0.222-0.438,0.47-0.424 c0.245,0.012,0.435,0.223,0.424,0.47C703.393,577.678,703.18,577.869,702.934,577.854z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M702.152,576.801c-0.232-0.012-0.414-0.207-0.4-0.443c0.013-0.233,0.209-0.414,0.443-0.401 c0.233,0.011,0.414,0.21,0.401,0.442C702.588,576.631,702.387,576.815,702.152,576.801z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M701.374,575.746c-0.22-0.012-0.393-0.199-0.38-0.42c0.012-0.219,0.197-0.387,0.418-0.38 c0.221,0.011,0.391,0.199,0.38,0.421C701.782,575.584,701.593,575.757,701.374,575.746z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M700.237,574.297c0.011-0.205,0.185-0.367,0.394-0.357c0.207,0.01,0.367,0.185,0.356,0.392 c-0.009,0.205-0.189,0.371-0.393,0.356C700.387,574.676,700.225,574.504,700.237,574.297z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M705.375,577.325c-0.273,0.016-0.512-0.194-0.522-0.469c-0.014-0.278,0.201-0.51,0.475-0.522 c0.27-0.01,0.504,0.196,0.516,0.477C705.859,577.078,705.65,577.315,705.375,577.325z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M704.781,576.031c0.013,0.25-0.182,0.469-0.44,0.48c-0.258,0.01-0.479-0.184-0.489-0.439 c-0.013-0.259,0.188-0.473,0.444-0.488C704.551,575.573,704.768,575.768,704.781,576.031z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M703.719,575.25c0.012,0.236-0.172,0.44-0.412,0.451c-0.24,0.012-0.448-0.174-0.458-0.409 c-0.012-0.245,0.177-0.446,0.417-0.458C703.5,574.822,703.706,575.006,703.719,575.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M702.656,574.47c0.01,0.222-0.16,0.413-0.384,0.42c-0.224,0.011-0.417-0.161-0.427-0.383 c-0.008-0.225,0.166-0.412,0.39-0.424C702.455,574.072,702.646,574.245,702.656,574.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M700.845,573.727c-0.011-0.211,0.152-0.387,0.358-0.395c0.205-0.01,0.383,0.15,0.393,0.358 c0.01,0.206-0.15,0.383-0.357,0.391C701.032,574.092,700.852,573.93,700.845,573.727z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M701.773,572.725c0.205-0.029,0.4,0.113,0.43,0.32c0.029,0.206-0.113,0.4-0.32,0.427 c-0.207,0.034-0.4-0.112-0.431-0.319C701.425,572.945,701.568,572.755,701.773,572.725z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M703.557,573.596c0.033,0.217-0.119,0.42-0.337,0.45c-0.218,0.034-0.421-0.12-0.452-0.334 c-0.029-0.218,0.122-0.424,0.338-0.454C703.32,573.229,703.525,573.379,703.557,573.596z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M704.912,574.143c0.035,0.233-0.125,0.443-0.355,0.477c-0.227,0.034-0.444-0.127-0.477-0.352 c-0.031-0.227,0.129-0.442,0.355-0.476C704.663,573.756,704.878,573.915,704.912,574.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M706.264,574.695c0.039,0.24-0.131,0.461-0.371,0.498c-0.238,0.034-0.465-0.131-0.496-0.371 c-0.035-0.24,0.131-0.465,0.369-0.499C706.006,574.286,706.23,574.455,706.264,574.695z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M707.618,575.246c0.038,0.252-0.138,0.484-0.387,0.521c-0.251,0.039-0.487-0.138-0.521-0.387 c-0.034-0.251,0.139-0.487,0.387-0.525C707.348,574.822,707.581,574.996,707.618,575.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M708.973,575.798c0.042,0.263-0.142,0.507-0.404,0.544c-0.26,0.038-0.508-0.146-0.545-0.404 c-0.037-0.264,0.144-0.511,0.405-0.548C708.691,575.352,708.935,575.536,708.973,575.798z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B6A58",
    d: "M709.762,575.922c0.273-0.037,0.527,0.154,0.566,0.428c0.041,0.271-0.15,0.525-0.42,0.567 c-0.275,0.041-0.533-0.15-0.566-0.424C709.299,576.218,709.488,575.963,709.762,575.922z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanBackground);
export default __webpack_public_path__ + "static/media/plan-background.daffcff91646fa2929f601c4143e92e6.svg";
export { ForwardRef as ReactComponent };